"use strict";
import React from "react";
import _ from "underscore";
import s from "underscore.string";
function bouncedEmails(props, state) {
  return _.intersection(props.recipients, state.bouncedEmails);
}
function emails(props, state) {
  return s.toSentenceSerial(bouncedEmails(props, state));
}
export default React.createClass({
  getInitialState: function() {
    return {
      bouncedEmails: []
    };
  },
  componentDidMount: function() {
    this.fetchBounces(this.props.recipients);
  },
  componentWillReceiveProps: function(nextProps) {
    if (!_.isEqual(nextProps.recipients, this.props.recipients)) {
      this.fetchBounces(nextProps.recipients);
    }
  },
  render: function() {
    if (_.isEmpty(bouncedEmails(this.props, this.state))) {
      return null;
    } else {
      return /* @__PURE__ */ React.createElement("div", { className: "alert-box--caution accounts-payable-bounces-message" }, "We were previously unable to send to", " ", /* @__PURE__ */ React.createElement("strong", null, emails(this.props, this.state)), "... should we try again? ", this.ignoreLink(), ".");
    }
  },
  ignoreLink: function() {
    return /* @__PURE__ */ React.createElement("a", { onClick: this.ignoreBounces }, "Yes, please");
  },
  setBouncedEmails: function(bounces) {
    const emails2 = _.map(bounces, "email");
    this.setState({ bouncedEmails: emails2 });
  },
  fetchBounces: function(recipients) {
    if (_.isEmpty(_.compact(recipients))) {
      this.setBouncedEmails([]);
      return;
    }
    jQuery.get({
      url: "/api/bouncing_email_addresses",
      data: { emails: recipients },
      success: this.setBouncedEmails
    });
  },
  ignoreBounces: function() {
    jQuery.ajax({
      url: "/api/bouncing_email_addresses",
      method: "DELETE",
      data: { emails: bouncedEmails(this.props, this.state) },
      success: this.setBouncedEmails
    });
  }
});
